import { call, put, takeEvery } from 'redux-saga/effects';
import { SendApiRequest } from 'src/api';
import { apiRoutes } from 'src/api/routes';
import {
    fetchSkills,
    skillsFetched,
    skillsFetchRequestFailed,
    fetchSubSkills,
    subSkillsFetched,
    subSkillsFetchRequestFailed,
} from '../skills';

function* fetchSkillsEffect() {
    try {
        const response = yield call(SendApiRequest, {
            url: apiRoutes.skillsByJson,
            method: 'GET',
        });
        yield put(skillsFetched(response));
    } catch (e) {
        yield put(skillsFetchRequestFailed());
    }
}

function* fetchSubSkillsEffect() {
    try {
        const response = yield call(SendApiRequest, {
            url: apiRoutes.getSubSkills,
            method: 'GET',
        });
        yield put(subSkillsFetched(response));
    } catch (e) {
        yield put(subSkillsFetchRequestFailed());
    }
}

export const skillsSagas = [
    takeEvery(fetchSkills.type, fetchSkillsEffect),
    takeEvery(fetchSubSkills.type, fetchSubSkillsEffect),
];
